import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import TitleSection from "@/pages/checkout/arib-finance/component/TitleSection";
import { useTranslation } from "@i18n";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import { useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import useApi from "@hooks/useApi";
import { api__createAribPaymentSession } from "@/apis/checkout/createSession";
import useHelpers from "@hooks/useHelpers";
import { toast } from "sonner";
import PaymentFormComponent from "@/pages/checkout/arib-finance/component/PaymentFormComponent";
import Loader3d from "@/pages/checkout/finance-checkout/FreeFinanceComponents/Loader3d";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import useBoolean from "@hooks/useBoolean";
import api__getOrderDetails from "@/apis/arib/api__getOrderDetails";
import { trackEvents } from "@/common/events/events";
import useIsIOS from "@hooks/useIsIOS";
import useIsMobile from "@hooks/useIsMobile";
import useCheckABFlag from "@hooks/useCheckABFlag";
import useSupportGooglePay from "@hooks/useSupportGooglePay";
import useIsWebView from "@hooks/useIsWebview";
var showErrorToast = function showErrorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    duration: 5000,
    style: {
      zIndex: 9999999
    }
  });
};
var PaymentComponent = function PaymentComponent() {
  var _useAribFinance, _useAribFinance$state2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var orderData = useAribFinance().state.orderData;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrlAbsolute = _useHelpers.createUrlAbsolute,
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t,
    tLong = _useTranslation2.tLong;
  var post_id = useAribFinance().queryParams.post_id;
  var _useAribFinance$state = (_useAribFinance = useAribFinance()) === null || _useAribFinance === void 0 ? void 0 : (_useAribFinance$state2 = _useAribFinance.state) === null || _useAribFinance$state2 === void 0 ? void 0 : _useAribFinance$state2.orderData,
    order_id = _useAribFinance$state.order_id;
  var isIos = useIsIOS();
  var isMobile = useIsMobile();
  var isWebView = useIsWebView();
  var supportGooglePay = useSupportGooglePay();
  var location = useLocation();
  var params = new URLSearchParams(location.search);
  var payment_success = params.get("payment_success");
  var paymentMessage = params.get("paymentMessage");
  var shouldFetch = payment_success === "0";
  var _useApi = useApi(shouldFetch ? [order_id] : null, shouldFetch ? function () {
      return api__getOrderDetails(Number(order_id));
    } : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            return _context.a(2);
        }
      }, _callee);
    }))),
    _useApi2 = _slicedToArray(_useApi, 3),
    _ = _useApi2[0],
    detailsError = _useApi2[1],
    detailsData = _useApi2[2];
  useEffect(function () {
    if (detailsData && payment_success === '0') {
      var _detailsData$data;
      var url = new URL(window.location.href);
      url.searchParams["delete"]("payment_success");
      url.searchParams["delete"]("paymentMessage");
      window.history.replaceState({}, "", url);
      if (detailsData && detailsData !== null && detailsData !== void 0 && (_detailsData$data = detailsData.data) !== null && _detailsData$data !== void 0 && _detailsData$data.data) {
        var data = detailsData.data.data;
        var g4_data = (data === null || data === void 0 ? void 0 : data.g4_data) || {};
        var eventPayload = {
          order_id: data.order_id || data.id,
          post_id: post_id,
          payment_type: data === null || data === void 0 ? void 0 : data.payment_type,
          payment_status: data === null || data === void 0 ? void 0 : data.payment_status,
          response_code: (data === null || data === void 0 ? void 0 : data.response_code) || null,
          response_message: (data === null || data === void 0 ? void 0 : data.response_message) || null,
          inventory_type: (g4_data === null || g4_data === void 0 ? void 0 : g4_data.inventory_type) || null,
          total_amount: (data === null || data === void 0 ? void 0 : data.display_amount) || null,
          payment_option: data === null || data === void 0 ? void 0 : data.payment_option,
          post_make: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_make,
          post_model: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_model,
          post_year: g4_data === null || g4_data === void 0 ? void 0 : g4_data.post_year,
          fees: data === null || data === void 0 ? void 0 : data.amount
        };
        trackEvents("finance_payment_submit", _objectSpread({}, eventPayload));
      }
      toast.error(paymentMessage, {
        position: "top-center",
        duration: 5000,
        style: {
          zIndex: 9999999
        }
      });
    }
  }, [payment_success, detailsData]);
  var confirm = useBoolean();
  var AB_PAYMENT_CHECKOUT = useCheckABFlag("AB_PAYMENT_CHECKOUT.COM");
  var AB_PAYMENT_MOYASAR = useCheckABFlag("AB_PAYMENT_MOYASAR");
  var AB__gateway_type = AB_PAYMENT_CHECKOUT === true ? "checkout.com" : AB_PAYMENT_MOYASAR === true ? "moyasar" : null;
  // Determine gateway type based on AB flags and device conditions
  // Show Google Pay (checkout.com) when:
  // - Mobile Android NOT in WebView: always
  // - Mobile Android in WebView: only if supportGooglePay is true
  var shouldUseCheckoutCom = false; //isMobile && !isIos && (!isWebView || supportGooglePay);
  var gatewayType = AB__gateway_type !== null && AB__gateway_type !== void 0 ? AB__gateway_type : shouldUseCheckoutCom ? "checkout.com" : null;
  var _useApi3 = useApi([order_id, isWebView, supportGooglePay, AB__gateway_type], function () {
      return api__createAribPaymentSession(_objectSpread({
        order_id: order_id,
        paymentProcessingUrl: paymentProcessingUrl
      }, gatewayType ? {
        gateway_type: gatewayType
      } : {}));
    }),
    _useApi4 = _slicedToArray(_useApi3, 3),
    loading = _useApi4[0],
    error = _useApi4[1],
    apiData = _useApi4[2];
  var paymentProcessingUrl = createUrlAbsolute("/finance-apply-arib", {
    post_id: post_id,
    financestep: 11,
    total_amount: apiData === null || apiData === void 0 ? void 0 : apiData.total_amount
  }).replace('localhost:3000', 'https://local.syarah.com');
  var _ref2 = apiData || {},
    session = _ref2.session,
    checkoutOrder = _ref2.order_details;
  var showLoading = loading || !checkoutOrder && !error;
  useEffect(function () {
    if (error) {
      console.error({
        error: error
      });
      showErrorToast(error.message);
    }
  }, [error]);
  if (showLoading) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Loader3d, null));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "lg:flex lg:gap-[22px] lg:max-w-[992px] lg:mx-auto lg:pt-8 justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lg:bg-white lg:rounded-xl lg:border lg:border-solid lg:border-[#EBF0F7] lg:py-8 lg:px-6  flex-[0.6]"
  }, /*#__PURE__*/React.createElement(TitleSection, {
    step: 10
  }), /*#__PURE__*/React.createElement(PaymentFormComponent, {
    session: session,
    checkoutOrder: checkoutOrder,
    post_id: post_id,
    paymentProcessingUrl: paymentProcessingUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-full px-4 flex flex-col gap-4 mt-3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center text-[#6C7A8D] text-xs font-medium"
  }, tShort("arib/payment_not_qualified_note", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center text-xs font-medium",
    onClick: confirm.setTrue
  }, /*#__PURE__*/React.createElement("span", {
    className: " text-gray-causeway"
  }, tShort("arib/payment_terms_and_services_text", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-primary underline cursor-pointer"
  }, tShort("arib/payment_terms_and_services_link", {
    ns: "web_checkout_finance"
  }))))), /*#__PURE__*/React.createElement(SharedPopUp, {
    oowh: true,
    show: confirm.value,
    onClose: confirm.setFalse
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-full w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 text-center py-10 px-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-primary font-bold text-xl"
  }, tShort("arib/payment_terms_and_conditions_title", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-primary text-base"
  }, tLong("arib/payment_terms_and_conditions_description", {
    ns: "web_checkout_finance"
  })))))));
};
export default PaymentComponent;